export const environment = {
  production: false,
  clientId: "4d9615ef-1ba0-4f87-b8b1-af32330a7889",
  requiredScopes: ["c48e6ffc-1b53-44fc-94bb-4a213dc461ed/user_impersonation"],
  apiHost: "https://tst-api-apim.azure-api.net",
  outhRedirectUrl: "https://stammdaten.persona-cloud-test123.de/redirect-callback",
  apiBaseUrl: "stammdaten-admin/v1/de"
};
